module.exports = __webpack_public_path__ + "media/11_13.4c3cadfa.wav";